export const translate = key => window.__litium.translation[key] || key;